module.exports = __webpack_public_path__ + "img/contenedor27.130c19ce.png";